
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aRJm6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $33eadb3f1526e06e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $33eadb3f1526e06e$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': "\u30A2\u30AF\u30B7\u30E7\u30F3",
    'ai-smart-button.ai-actions.give-feedback-action.title': "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u9001\u4FE1",
    'ai-smart-button.ai-actions.help.section.text': "\u30D8\u30EB\u30D7",
    'ai-smart-button.ai-actions.input.link-picker-button-label': "\u30EA\u30F3\u30AF",
    'ai-smart-button.ai-actions.input.mention-button-label': "\u30E1\u30F3\u30B7\u30E7\u30F3",
    'ai-smart-button.ai-actions.input.send-button-label': "\u9001\u4FE1",
    'ai-smart-button.ai-actions.item.betaLozenge': "\u30D9\u30FC\u30BF\u7248",
    'ai-smart-button.ai-actions.item.newLozenge': 'NEW',
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "\u30A2\u30A4\u30B3\u30F3\u3092\u8FFD\u52A0",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "\u81EA\u52D5\u5316\u30A2\u30A4\u30B3\u30F3",
    'ai-smart-button.ai-actions.rovo-agents.automations.text': "\u81EA\u52D5\u5316",
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': "\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3092\u898B\u308B",
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "\u81EA\u52D5\u5316\u3092\u4F5C\u6210",
    'ai-smart-button.ai-actions.rovo-agents.section.text': "\u30B9\u30BF\u30B8\u30AA",
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': "{name} \u3055\u3093\u3001",
    'ai-smart-button.ai-proactive-nudge.dismiss': "\u9589\u3058\u308B",
    'ai-smart-button.feedback-action.ask-question-option': "\u8CEA\u554F\u3057\u3066\u304F\u3060\u3055\u3044",
    'ai-smart-button.feedback-action.cancel-button-label': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'ai-smart-button.feedback-action.choose-feedback-option': "1 \u3064\u9078\u629E",
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': "\u30D0\u30B0\u307E\u305F\u306F\u8AB2\u984C\u306E\u8AAC\u660E\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "\u5177\u4F53\u7684\u306A\u5185\u5BB9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "\u3054\u8CEA\u554F\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "\u6539\u826F\u3092\u5E0C\u671B\u3059\u308B\u70B9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
    'ai-smart-button.feedback-action.feedback-modal-heading': "\u3054\u610F\u898B\u3092\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044",
    'ai-smart-button.feedback-action.leave-comment-option': "\u30B3\u30E1\u30F3\u30C8\u3092\u6B8B\u3059",
    'ai-smart-button.feedback-action.report-bug-option': "\u30D0\u30B0\u3092\u5831\u544A\u3059\u308B",
    'ai-smart-button.feedback-action.research-participation-message': "\u88FD\u54C1\u8ABF\u67FB\u306B\u53C2\u52A0\u3059\u308B",
    'ai-smart-button.feedback-action.select-feedback-heading': "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'ai-smart-button.feedback-action.submit-button-label': "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u9001\u4FE1",
    'ai-smart-button.feedback-action.suggest-improvement-option': "\u6539\u826F\u70B9\u3092\u63D0\u6848\u3059\u308B",
    'ai-smart-button.feedback-action.title': "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u9001\u4FE1",
    'ai-smart-button.feedback-item.icon-label': "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF \u30A2\u30A4\u30B3\u30F3",
    'ai-smart-button.reference.close-button-label': "\u9589\u3058\u308B"
};

});


//# sourceMappingURL=ja.a28166f5.js.map
